(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid-2col"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('editorial-product-panels')) return;
    class EditorialProductPanels extends HTMLElement {
      connectedCallback() { this.initFrame = requestAnimationFrame(() => this.setup()); }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.resizeFrame);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
      }
      setup() {
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        // clientWidth excluye la barra vertical: ancho completo sin desbordamiento horizontal.
        const fitWidth = () => {
          const width = document.documentElement.clientWidth;
          if (width > 0 && this.viewportWidth !== width) {
            this.viewportWidth = width;
            this.style.setProperty('--ep-viewport', `${width}px`);
          }
        };
        fitWidth();
        const queueWidth = () => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(fitWidth);
        };
        window.addEventListener('resize', queueWidth, { signal, passive: true });
        this.resizeObserver = new ResizeObserver(queueWidth);
        this.resizeObserver.observe(document.documentElement);
        this.querySelectorAll('.ep__secondary-image').forEach(img => {
          const card = img.closest('.ep__card');
          const ready = () => {
            // La segunda imagen también se carga y se muestra en dispositivos táctiles.
            card.classList.toggle('is-photo-ready', img.complete && img.naturalWidth > 1);
          };
          img.addEventListener('load', ready, { signal });
          let photoFailed = img.complete && img.naturalWidth === 0;
        img.addEventListener('error', () => {
          photoFailed = true;
          card.classList.remove('is-photo-ready', 'is-touch-preview');
        }, { signal });
        img.addEventListener('load', () => { photoFailed = false; }, { signal });
          ready();
          card.addEventListener('pointerenter', () => { img.loading = 'eager'; }, { signal });
          card.addEventListener('focusin', () => { img.loading = 'eager'; }, { signal });

        let gesture = null;
        card.addEventListener('pointerdown', event => {
          gesture = null;
          if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
          if (!event.isPrimary || photoFailed) return;

          const wasOpen = card.classList.contains('is-touch-preview') &&
            card.classList.contains('is-photo-ready');
          this.querySelectorAll('.is-touch-preview').forEach(other => {
            if (other !== card) other.classList.remove('is-touch-preview');
          });
          gesture = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            startedAt: Date.now(),
            endedAt: 0,
            wasOpen,
            moved: false,
            cancelled: false
          };
          img.loading = 'eager';
          card.classList.add('is-touch-preview');
        }, { signal, passive: true });

        card.addEventListener('pointermove', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) {
            gesture.moved = true;
          }
        }, { signal, passive: true });

        card.addEventListener('pointerup', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          gesture.endedAt = Date.now();
          if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) {
            gesture.moved = true;
          }
        }, { signal, passive: true });

        card.addEventListener('pointercancel', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          gesture.cancelled = true;
          gesture.endedAt = Date.now();
          // El navegador puede tomar el gesto para desplazar la página.
          // Conservamos la foto visible sin bloquear el scroll.
        }, { signal, passive: true });

        card.addEventListener('click', event => {
          // Conserva la navegación con ratón, teclado y tecnologías de asistencia.
          if (!gesture || photoFailed || event.detail === 0) return;
          const current = gesture;
          gesture = null;
          if (!current.endedAt || Date.now() - current.endedAt > 1000) return;

          const held = current.endedAt - current.startedAt > 500;
          if (!current.wasOpen || current.moved || current.cancelled || held) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          // Primer toque: foto. Segundo toque: enlace, si existe.
          if (!card.querySelector('.ep__link')) card.classList.remove('is-touch-preview');
        }, { signal, capture: true });
        });
        document.addEventListener('pointerdown', event => {
        this.querySelectorAll('.is-touch-preview').forEach(card => {
          if (!card.contains(event.target)) card.classList.remove('is-touch-preview');
        });
      }, { signal, passive: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('.is-touch-preview').forEach(card => {
          card.classList.remove('is-touch-preview');
        });
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ep__card');
          if (!card || !this.contains(card)) return;
          card.classList.add('is-editor-preview');
          const img = card.querySelector('.ep__secondary-image');
          if (img) img.loading = 'eager';
        }, { signal });
        this.addEventListener('shopify:block:deselect', event => {
          event.target.closest('.ep__card')?.classList.remove('is-editor-preview');
        }, { signal });
      }
    }
    customElements.define('editorial-product-panels', EditorialProductPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    

  (() => {

    if (customElements.get('editorial-product-carousel')) return;

    class EditorialProductCarousel extends HTMLElement {

      connectedCallback() {

        this.setupFrame = requestAnimationFrame(() => this.setup());

      }

      disconnectedCallback() {

        cancelAnimationFrame(this.setupFrame);

        cancelAnimationFrame(this.scrollFrame);

        clearTimeout(this.statusTimer);

        this.abort?.abort();

        this.resizeObserver?.disconnect();

        this.removeAttribute('data-ready');

      }

      setup() {

        this.abort?.abort();

        this.resizeObserver?.disconnect();

        this.abort = new AbortController();

        const signal = this.abort.signal;

        this.track = this.querySelector('[data-track]');

        if (!this.track) return;

        this.items = Array.from(this.track.children);

        this.loop = this.dataset.loop === 'true';

        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

        this.drag = null;

        this.suppressClick = false;

        this.addEventListener('click', event => {

          if (this.suppressClick) {

            event.preventDefault(); event.stopPropagation(); this.suppressClick = false; return;

          }

          const photoButton = event.target.closest('[data-photo-step]');

          if (photoButton) {

            event.preventDefault(); event.stopPropagation();

            this.changePhoto(photoButton.closest('[data-gallery]'), Number(photoButton.dataset.photoStep));

            return;

          }

          const productButton = event.target.closest('[data-product-step]');

          if (productButton) {

            event.preventDefault();

            this.move(Number(productButton.dataset.productStep));

          }

        }, { signal, capture: true });

        this.track.addEventListener('keydown', event => {

          // Los controles de cada foto conservan su funcionamiento nativo con Enter/Espacio.

          if (event.target !== this.track) return;

          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();

          if (event.key === 'Home') this.scrollToPosition(0);

          else if (event.key === 'End') this.scrollToPosition(this.maxScroll());

          else this.move(event.key === 'ArrowRight' ? 1 : -1);

        }, { signal });

        this.track.addEventListener('scroll', () => {

          cancelAnimationFrame(this.scrollFrame);

          this.scrollFrame = requestAnimationFrame(() => this.update());

          clearTimeout(this.statusTimer);

          this.statusTimer = setTimeout(() => {

            const status = this.querySelector('[data-track-status]');

            if (status && this.items.length) status.textContent = `Producto ${this.currentIndex() + 1} de ${this.items.length}`;

          }, 180);

        }, { signal, passive: true });

        // En pantallas táctiles se conserva el desplazamiento nativo, incluido el vertical.

        this.track.addEventListener('pointerdown', event => {

          this.suppressClick = false;

          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;

          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };

        }, { signal });

        window.addEventListener('pointermove', event => {

          if (!this.drag || event.pointerId !== this.drag.id) return;

          const dx = event.clientX - this.drag.x;

          const dy = event.clientY - this.drag.y;

          if (!this.drag.active && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 7) { this.drag = null; return; }

          if (!this.drag.active && Math.abs(dx) > 7) {

            this.drag.active = true;

            this.track.classList.add('is-dragging');

            this.track.setPointerCapture(event.pointerId);

          }

          if (!this.drag.active) return;

          event.preventDefault();

          this.track.scrollLeft = this.drag.left - dx;

        }, { signal, passive: false });

        const finishDrag = event => {

          if (!this.drag || (event.pointerId !== undefined && event.pointerId !== this.drag.id)) return;

          const { active, id } = this.drag;

          this.drag = null;

          if (active) {

            this.suppressClick = true;

            if (this.track.hasPointerCapture(id)) this.track.releasePointerCapture(id);

            this.track.classList.remove('is-dragging');

            this.snap();

          }

        };

        window.addEventListener('pointerup', finishDrag, { signal });

        window.addEventListener('pointercancel', finishDrag, { signal });

        window.addEventListener('blur', finishDrag, { signal });

        this.track.addEventListener('lostpointercapture', finishDrag, { signal });

        this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });

        this.addEventListener('pointerdown', () => { this.suppressClick = false; }, { signal, capture: true });

        this.addEventListener('keydown', () => { this.suppressClick = false; }, { signal, capture: true });

        // Con ratón: al entrar en la foto se muestra la segunda y al salir vuelve siempre la primera.

        this.querySelectorAll('[data-gallery]').forEach(gallery => {

          gallery.addEventListener('pointerenter', event => {

            if (event.pointerType !== 'mouse' || this.drag?.active) return;

            if (Number(gallery.dataset.count || 0) > 1) this.showPhoto(gallery, 1, false);

          }, { signal });

          gallery.addEventListener('pointerleave', event => {

            if (event.pointerType !== 'mouse') return;

            if (Number(gallery.dataset.count || 0) > 1) this.showPhoto(gallery, 0, false);

          }, { signal });

        });

        this.resizeObserver = new ResizeObserver(() => this.update());

        this.resizeObserver.observe(this.track);

        this.setAttribute('data-ready', '');

        this.update();

      }

      maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }

      positions() {

        const gutter = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;

        const left = this.track.getBoundingClientRect().left;

        const max = this.maxScroll();

        return this.items.map(item => Math.max(0, Math.min(max, item.getBoundingClientRect().left - left + this.track.scrollLeft - gutter)));

      }

      currentIndex() {

        const positions = this.positions();

        let best = 0;

        positions.forEach((position, index) => {

          if (Math.abs(position - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft)) best = index;

        });

        return best;

      }

      scrollToPosition(left) {

        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });

      }

      move(direction) {

        const max = this.maxScroll();

        const current = this.track.scrollLeft;

        if (max <= 2) return;

        if (direction > 0 && current >= max - 2) { if (this.loop) this.scrollToPosition(0); return; }

        if (direction < 0 && current <= 2) { if (this.loop) this.scrollToPosition(max); return; }

        const positions = [...new Set(this.positions())];

        const target = direction > 0 ? positions.find(position => position > current + 2) : positions.reverse().find(position => position < current - 2);

        this.scrollToPosition(target ?? (direction > 0 ? max : 0));

      }

      snap() {

        const positions = this.positions();

        if (positions.length) this.scrollToPosition(positions[this.currentIndex()]);

      }

      update() {

        const max = this.maxScroll();

        const navigation = this.querySelector('[data-navigation]');

        if (navigation) navigation.hidden = max <= 2;

        this.querySelectorAll('[data-product-step]').forEach(button => {

          button.disabled = max <= 2 || (!this.loop && (Number(button.dataset.productStep) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2));

        });

        const position = this.querySelector('[data-position]');

        if (position) {

          const bounds = this.track.getBoundingClientRect();

          const visible = this.items.map((item, index) => ({ index, rect: item.getBoundingClientRect() })).filter(item => item.rect.right > bounds.left + 2 && item.rect.left < bounds.right - 2);

          position.textContent = visible.length ? `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${this.items.length}` : '';

        }

      }

      changePhoto(gallery, step) {

        if (!gallery) return;

        return this.showPhoto(gallery, Number(gallery.dataset.index) + step);

      }

      async showPhoto(gallery, targetIndex, announce = true) {

        if (!gallery) return;

        const frames = Array.from(gallery.querySelectorAll('[data-photo]'));

        if (frames.length < 2) return;

        const nextIndex = ((targetIndex % frames.length) + frames.length) % frames.length;

        gallery.dataset.index = String(nextIndex);

        const next = frames[nextIndex];

        // Si esa foto ya está a la vista (el cursor salió antes de que cargara la otra), no se repite la transición.

        if (!next.hidden) { gallery.removeAttribute('aria-busy'); return; }

        const template = next.querySelector('template');

        if (template) template.replaceWith(template.content.cloneNode(true));

        const img = next.querySelector('img');

        gallery.setAttribute('aria-busy', 'true');

        // Conserva la foto actual hasta que termine de cargar la siguiente.

        try { if (img?.decode) await img.decode(); } catch (_) { /* Permite continuar si el CDN no responde. */ }

        if (!this.isConnected || Number(gallery.dataset.index) !== nextIndex) return;

        gallery.removeAttribute('aria-busy');

        if (img && !img.naturalWidth) {

          const current = frames.findIndex(frame => !frame.hidden);

          gallery.dataset.index = String(Math.max(0, current));

          const status = gallery.querySelector('[data-photo-status]');

          if (status && announce) status.textContent = 'No se pudo cargar esta foto. Inténtalo de nuevo.';

          return;

        }

        frames.forEach((frame, index) => {

          frame.hidden = index !== nextIndex;

          frame.setAttribute('aria-hidden', String(index !== nextIndex));

          frame.classList.toggle('is-entering', index === nextIndex);

        });

        const status = gallery.querySelector('[data-photo-status]');

        if (status && announce) status.textContent = `Foto ${nextIndex + 1} de ${frames.length}`;

      }

    }

    customElements.define('editorial-product-carousel', EditorialProductCarousel);

  })();


  } catch(e) { console.error(e); }
})();
})();
